// @flow

export function permiteDownload(n : number, limite : number) {
  return Number.isInteger(n) && Number.isInteger(limite) && n <= limite;
}